import InputField from "components/fields/InputField";
import { MdOutlineCloudUpload } from "react-icons/md";
import DropZonefile from "views/admin/settingsProduct/components/DropZonefile";
import React, { useState, useEffect, useRef } from 'react';
import TextField from "components/fields/TextField";
import RichTextEditor from "components/fields/RichTextEditorField";
import ReactQuill from 'react-quill';
import 'quill/dist/quill.snow.css'; 
import { setEventTitle,setEventDescription, EventStatePayload } from '../../../../../redux/eventSlice';
import { RootState } from '../../../../../redux/store';
import { useSelector, useDispatch } from 'react-redux';
type CreateEventProps = {
  eventObject?: EventStatePayload;
  eventId?: string;     
};
const UploadFile = ({ eventObject, eventId }:CreateEventProps) => {
    console.log('eventObject__',eventObject);
    const dispatch = useDispatch();
    const quillRef = useRef(null);
    useEffect(() => {
      if (quillRef.current) {
        const editor = quillRef.current.getEditor().root;
        editor.style.minHeight = '350px';
      }
    }, []);
    const event = useSelector((state: RootState) => state.event.payload);

    const [uploadOption, setUploadOption] = useState('withUpload');
    const [imgUrl , setImgUrl] = useState(null);
    useEffect(() => {
      if(eventObject){
        dispatch(setEventTitle(eventObject.eventTitle));
        if(eventObject.eventDescription && eventObject.eventDescription !== ''){
          dispatch(setEventDescription(eventObject.eventDescription));
          setUploadOption('withoutUpload');
          setUploadOption('withUpload');
          //5a2963d2-ce19-4f7c-a7ef-c405b8cdfa6b
          //${eventObject.videoId}

        }
      }
    }, [eventObject]); 
  const handleUploadOptionChange = (event:any) => {
    setUploadOption(event.target.value);
  };

  const handleEventNameChange = (event:any) => {
    dispatch(setEventTitle(event.target.value));
  }
  const handleContentChange = (value:string) => {
        dispatch(setEventDescription(value));

  };

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      {/* Header */}
  
      {/* content */}
      <div className="mt-4">
        <InputField
          extra="mb-3"
          label="Event Name *"
          placeholder="Event Name"
          id="heading"
          type="text"
          value={event.eventTitle}
          onChange={handleEventNameChange}
        />
      </div>

      {uploadOption === 'withUpload' && (
        <>
        {imgUrl ? (
          <div className="mt-6 flex w-full items-center justify-center rounded-[20px] md:px-1">
              <img
                src={imgUrl}
                className="mb-3 w-64 h-48 mt-5 rounded-xl 3xl:h-full 3xl:w-full"
                alt=""
              />
          </div>
            ) : 
            null}
         <div className="mt-4 md:px-3">
        
          <b>  Upload knowledge *</b>
        </div>
      <div className="mt-6 flex w-full items-center justify-center rounded-[20px] md:px-1">

        <DropZonefile
          content={
            <div className="flex h-[225px] w-full flex-col items-center justify-center rounded-xl border-[1px] border-dashed border-gray-200 bg-gray-100 dark:!border-none dark:!bg-navy-800 sm:w-[300px] md:w-[570px] lg:w-[800px] xl:w-[600px] 2xl:w-[690px] 3xl:w-[680px]">
              <p className="text-[80px] text-navy-700">
                <MdOutlineCloudUpload className="text-brand-500 dark:text-white" />
              </p>
              <p className="text-lg font-bold text-navy-700 dark:text-white">
                Drop / Change  your Upload here, or{" "}
                <span className="font-bold text-brand-800 dark:text-brand-400">
                  browse
                </span>
              </p>
              <p className="pt-2 text-sm text-gray-800">
                Only PDF files are allowed
              </p>
            </div>
            
          }
          eventObject={eventObject}
          eventId={eventId}
        />
      </div>
      
      </>
      )}

    </div>
  );
};

export default UploadFile;
